import { http } from '@/api/index';
import axios from 'axios';

http.CancelToken = axios.CancelToken;

let source;

export const getDashboardReminders = ({ start, end }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('/dashboard/reminders', {
    params: { start, end },
    cancelToken: source.token,
  });
};

export const getDashboardDealsBirthdays = ({ start, end }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('/dashboard/deals-birthdays', {
    params: { start, end },
    cancelToken: source.token,
  });
};

export const getDashboardStarts = ({ start, end }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('/dashboard/starts', {
    params: { start, end },
    cancelToken: source.token,
  });
};

export const getDashboardCandidatesProcesses = ({ start, end, coachId }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('/dashboard/kpis/process/me', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
};

export const getTopPerformersCandidatesProcesses = ({ start, end }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('/dashboard/kpis/process/top-performers', {
    params: { start, end },
    cancelToken: source.token,
  });
};

export const getDashboardNewNotesSigned = ({ start, end, coachId }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('dashboard/kpis/clients/notes-signed', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
}

export const getDashboardNewNotesUnsigned = ({ start, end, coachId }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('dashboard/kpis/clients/notes-unsigned', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
}

export const getDashboardNewSigned = ({ start, end, coachId }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('dashboard/kpis/clients/signed', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
}

export const getDashboardNewContacted = ({ start, end, coachId }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('dashboard/kpis/candidates/contacted', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
}

export const getDashboardNewQualifications = ({ start, end, coachId }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('dashboard/kpis/candidates/qualified', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
}

export const getDashboardCandidatesMultiposting = ({ start, end, coachId } = {}) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('dashboard/kpis/candidates/multiposting', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
}

export const getDashboardNewOpportunities = ({ start, end, coachId }) => {
  // If there is a pending token, it will cancel the pending request
  if (source) {
    source.cancel('Operation canceled due to new request.');
  }

  source = http.CancelToken.source();

  return http.get('dashboard/kpis/opportunities/new', {
    params: { start, end, coachId },
    cancelToken: source.token,
  });
}

export default {
  getDashboardReminders,
  getDashboardDealsBirthdays,
  getDashboardStarts,

  getDashboardCandidatesProcesses,
  getTopPerformersCandidatesProcesses,

  getDashboardNewNotesSigned,
  getDashboardNewNotesUnsigned,
  getDashboardNewSigned,

  getDashboardNewContacted,
  getDashboardNewQualifications,

  getDashboardNewOpportunities
};
